import { AxiosInstance } from 'axios'

import { requestSuccessInterceptor, requestFailureInterceptor } from './interceptors/requestInterceptors'
import { responseSuccessInterceptor, responseFailureInterceptor } from './interceptors/responseInterceptors'

export const setupPublicInterceptors = (axiosInstance: AxiosInstance) => {
    axiosInstance.interceptors.request.use((config) => config, requestFailureInterceptor)
    axiosInstance.interceptors.response.use(responseSuccessInterceptor, (error) => Promise.reject(error))
}

export const setupPrivateInterceptors = (axiosInstance: AxiosInstance) => {
    axiosInstance.interceptors.request.use(requestSuccessInterceptor, requestFailureInterceptor)
    axiosInstance.interceptors.response.use(responseSuccessInterceptor, responseFailureInterceptor)
}
